<template>
  <SmallSquare content="可设置报销单自动取消规则、可报销的类型等" :padding='true' />
  <a-card :bordered="false">
    <a-form ref="ruleForm" :model="form" :rules="rules" >
      <a-form-item label="" name='' :wrapper-col="{ span: 18,offset:1}" style='margin-bottom: 10px;'>
        <div class="s_flex_ali">
          <p class="m-r-10" >提交报销单</p>
          <a-input-number v-model:value="form.single_time" class='m-r-10' style="width:20%;" :max="365" :min="1" :precision='0' />
          天后上级不进行操作，系统自动取消报销单
        </div>
      </a-form-item>
      <a-form-item label="" name='' :wrapper-col="{ span: 18,offset:1}" style='margin-bottom: 10px;'>
        <span>门店活动优惠券能否报销：</span>
        <a-radio-group v-model:value="form.status">
          <a-radio :value="1">能</a-radio>
          <a-radio :value="2">不能</a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item :wrapper-col="{ span: 4,offset:1}" class='m-t-25'>
        <a-button type="primary" v-has:reimburseSet="onSubmit">
          保存设置
        </a-button>
      </a-form-item>
    </a-form>
  </a-card>
</template>
<script>
import { ref, onMounted } from 'vue';
import { setReimbursement, getReimbursement } from '@/api/reimbursement';
import { iscode } from '@/utils/app';
import { message } from 'ant-design-vue';
// 初始化默认筛选项数值
let defForm = {
  status: 2,
  single_time: 30,
}
export default {
  setup() {
    const form = ref({ ...defForm });
    const ruleForm = ref()
    const onSubmit = async () => {
      const hide = message.loading("正在加载中...", 0);
      let res = await setReimbursement( form.value ).then((res) => res.data).catch(error=>error);
      if (iscode(res)) {
        message.success(res.msg);
        initData();
      } else {
        message.error(res.msg);
      }
      setTimeout(hide);
    };
    const initData = async () => {
      const hide = message.loading("正在加载中...", 0);
      let res = await getReimbursement().then((res) => res.data).catch(error=>error);
      if (iscode(res)) {
        form.value = res.data;
      } else {
        message.error(res.msg);
      }
      setTimeout(hide);
    };
    onMounted(() => {
      initData();
    });
    return {
      form,
      ruleForm,
      onSubmit,
    };
  },
};
</script>
